import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('unsettledPayments', app)
  function totalUnpaid(state) {
    let total = 0
    state.list.default.data.forEach((item) => {
      total += item.amount
    })
    return total
  }

  store.getters.totalUnpaid = totalUnpaid
  store.state.structure.selected = {
    type: 'bool',
    validation: [],
  }
  return store
}
